import { GrDashboard } from "react-icons/gr";

export const PERMS = Object.freeze({
  ADMIN_PANEL_VIEW: "admin.panel.view",

  STATIONS_LIST_READ: "stations.list.read",
  STATION_DETAIL_READ: "stations.detail.read",

  PRICES_APPROVE: "prices.approve",

  USER_ADMIN_PANEL: "user.admin.panel",
  STATION_ADMIN_PANEL: "station.admin.panel",

    // Armex
  ARMEX_EDIT: "prices.armex.edit",
  ARMEX_CONFIRM: "prices.armex.confirm",
  ARMEX_SCHEDULE: "prices.armex.schedule",
  ARMEX_SNAPSHOT: "prices.armex.snapshot",
  ARMEX_SHOP2000_VIEW: "prices.armex.shop2000.view",

  // Planned prices
  PLANNED_VIEW: "prices.planned.view",
  PLANNED_DELETE: "prices.planned.delete",

  PRICE_DIFFERENCE_VIEW: "prices.difference.view",

  // Nearby stations
  NEARBY_EDIT: "prices.nearby.edit",
  NEARBY_SUBMIT: "prices.nearby.submit",

  // User confirm flow
  USER_CONFIRM_CHANGES: "prices.user.confirm_changes",

  ARMEX_STATION_EDIT: "armex.station.edit",

  STATION_USER_ASSIGN: "station.user.assign",

  ADD_STATION: "station.add",

  STATION_DEACTIVATE: "station.deactivate",

  STATION_LIMITS_EDIT_DISPLAY: "station.limits.edit.display",

  NEARBY_STATION_EDIT: "nearby.station.edit",
  NEARBY_STATION_PAIR: "nearby.station.pair",

  DASHBOARD_VIEW: "dashboard.view",


});